import React from "react"
import cx from "classnames"

const LayoutSection = ({
  children,
  isPageHeader,
  className,
  headerLink,
}: {
  children: React.ReactNode
  isPageHeader?: boolean
  className?: string
  headerLink?: React.ReactNode
}) => {
  const hasHeaderLink = !!headerLink && isPageHeader
  return (
    <div
      className={cx("cobalt-layout-section", className, {
        "cobalt-layout--isPageHeader": isPageHeader,
        "cobalt-layout--hasHeaderLink": hasHeaderLink,
      })}
    >
      {hasHeaderLink && (
        <div className="cobalt-layout-header-link">{headerLink}</div>
      )}
      {children}
    </div>
  )
}

export default LayoutSection
